<div class="form-container" style="width: 30vw; min-width: 350px;">
  <form [formGroup]='setPasswordForm'>
    <div>

      <div class="p-g">
        <div class="form-field p-g-12 p-MD-12 p-lg-12 pl-0 pr-0">
          <div class="form-errors alert alert-danger" [hidden]='!passwordError[0]["general"]'>
            <div *ngFor="let ErrorMessage of passwordError['general']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
      </div>

      <div class="p-g">
        <div class="form-field p-g-12  pl-0 pr-0">
          <div class="form-label p-g-12 p-0">
            <label for="newPassword">New Password</label>
          </div>
          <div class="form-control p-g-12 p-0" style="position: relative;">
            <input [type]="showPassword? 'text':'password'" pInputText formControlName="newPassword" />
            <li [class]="showPassword? 'fa fa-eye':'fa fa-eye-slash'" (click)="showPassword = !showPassword"
              style="position: absolute;top:16px;right:10px"></li>
          </div>
          <div class="form-errors"
            *ngIf="setPasswordForm.controls.newPassword.errors  && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
            <div [hidden]="!setPasswordForm.controls.newPassword.errors.required">
              New Password is required
            </div>
              <div [hidden]="!setPasswordForm.controls.newPassword.errors.pattern" translate>
              lbl_password_pattern_error
            </div>
          </div>
        </div>
      </div>
      <div class="p-g">
        <div class="form-field p-g-12 p-0">
          <div class="form-label p-g-12 p-0">
            <label for="newConfirmPassword">New Confirm Password</label>
          </div>
          <div class="form-control p-g-12 p-0" style="position: relative;">
            <input [type]="showConfirmPassword? 'text':'password'" pInputText formControlName="newConfirmPassword" />
            <li [class]="showConfirmPassword? 'fa fa-eye':'fa fa-eye-slash'"
              (click)="showConfirmPassword = !showConfirmPassword" style="position: absolute;top:16px;right:10px"></li>
          </div>
          <div class="form-errors"
            *ngIf="setPasswordForm.controls.newConfirmPassword.errors  && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
            <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required">
              Please Confirm Password
            </div>
          </div>
        </div>

      </div>
      <div class="p-g">
        <div class="form-buttons p-g-12 p-0">
          <button pButton type="button" class="mr-0" label="Save" icon="fa fa-check" [disabled]="!setPasswordForm.valid"
            (click)="doChangePassword()"></button>
          <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel"
            (click)="onCancel()"></button>
        </div>
      </div>
    </div>
  </form>
</div>